import en from './en.json'
import zhCn from './zh-cn.json'
import zhTw from './zh-tw.json'

const map = {
  'en': en,
  'zh-cn': zhCn,
  'zh-tw': zhTw,
}

export const getDataTablesLang = (lang)=>map[lang]



// WEBPACK FOOTER //
// ./src/lang/datatables/index.js